module.exports = __webpack_public_path__ + "img/icon_test_resting.5fbe15cf.png";